import { clamp } from "lodash-es";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";
import {
	EARLY_FREEDOM_SAVING_FALLBACK,
	EARLY_FREEDOM_SAVING_MAX,
	EARLY_FREEDOM_SAVING_MIN,
} from "web_myplann/Inspiration/constants";

type EarlyFreedomBaseline = {
	age?: number;
	monthlySaving: number;
};

export const useEarlyFreedomBaseline = (): EarlyFreedomBaseline => {
	const { data: client } = useClientQuery();
	const { data: incomeData } = useIncomeQuery();
	const { data: expenseData } = useExpenseQuery();

	const age = (() => {
		const bornDate = client?.data?.bornDate;
		if (!bornDate) return undefined;
		const bornYear = new Date(bornDate).getFullYear();
		if (!Number.isFinite(bornYear)) return undefined;
		const years = new Date().getFullYear() - bornYear;
		return years > 0 && years < 120 ? years : undefined;
	})();

	const monthlySaving = (() => {
		const income =
			incomeData?.data?.reduce((sum, item) => sum + (item.amount ?? 0), 0) ?? 0;
		const expenses =
			expenseData?.data?.reduce(
				(sum, item) => sum + (item.monthlyPayment ?? 0),
				0,
			) ?? 0;
		const saving = income - expenses;
		return saving > 0
			? clamp(saving, EARLY_FREEDOM_SAVING_MIN, EARLY_FREEDOM_SAVING_MAX)
			: EARLY_FREEDOM_SAVING_FALLBACK;
	})();

	return { age, monthlySaving };
};
